// standard sign in
export const invalidCredentialErrorCodes = [
    'invalid.password.signin',
    'format.password.signin',
    'bad_characters_form.password.signin',
    'user.auth.args.email_address.invalid',
    'user.signin.account_not_found',
    // sign in with partial user's email
    'no_account..signin'
] as const;

export const socialLoginErrors = ['access_denied'];

export const accountLockoutErrorCode = 'account_lockout' as const;

export const ipLockErrorCode = 'signin_ip_lock' as const;

export const accountMigratedErrorCode = 'migrated_user_error' as const;

type InvalidCredentialErrorCode = typeof invalidCredentialErrorCodes[number];

export type SignInErrorCode = InvalidCredentialErrorCode | typeof accountLockoutErrorCode;

export const isInvalidCredentialErrorCode = (
    errorCode: string
): errorCode is InvalidCredentialErrorCode => {
    return invalidCredentialErrorCodes.some((code) => code === errorCode);
};

// DO NOT SORT ON KEYS
// error code from social sign in, i.e. POST auth code
export enum SocialSignInErrorCode {
    PROVIDER_SERVER_ERROR = 'user.auth.provider.server_error',
    PROVIDER_SOCIAL_LOGIN_FAILURE = 'user.auth.provider.social_login_signin_failed',
    PROVIDER_ACCESS_TOKEN_FAILURE_MISSING = 'user.auth.provider.access_token',
    PROVIDER_INVALID_ACCESS_TOKEN_MISSING = 'user.auth.provider.invalid.access_token',
    // Social account has already connected to another ELC account
    PROVIDER_ALREADY_CONNECTED = 'ramp.provider.already_connected_profile',
    PROVIDER_MOBILE_COUNTRY_CODE_NOT_ALLOWED = 'ramp.provider.mobile.country_code.not_allowed',
    PROVIDER_MOBILE_MISSING = 'ramp.provider.mobile.missing',
    PROVIDER_MOBILE_INVALID = 'ramp.provider.mobile.invalid',
    PROVIDER_EMAIL_MISSING = 'ramp.provider.email.missing'
}

//expect error code from 3rd party
export const isExpectedSocialLoginError = (errorCode: string) => {
    return socialLoginErrors.some((x) => x === errorCode.toLowerCase());
};

// expected error code from elc BE for social
export const isExpectedSocialError = (errorCode: string) => {
    return Object.values(SocialSignInErrorCode).includes(errorCode as SocialSignInErrorCode);
};

// if the error is something we would expect to happen, don't send to Sentry
export const isExpectedSignInErrorCode = (errorCode: string) => {
    return (
        isInvalidCredentialErrorCode(errorCode) ||
        errorCode === accountLockoutErrorCode ||
        errorCode === accountMigratedErrorCode ||
        errorCode === ipLockErrorCode ||
        isExpectedSocialError(errorCode)
    );
};
